/**
 * Forbrukerrådet - Kommunetesten
 * @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
 * @author Anders Evenrud <anders.evenrud@copyleft.no>
 */

export default {
  methods: {
    homeLink (query = {}) {
      return {
        name: 'home',
        query
      }
    },

    countyLink (fid, query = {}) {
      return {
        name: 'county',
        params: { fid },
        query
      }
    },

    municipalityLink (kid, query = {}) {
      return {
        name: 'municipality',
        params: { kid },
        query
      }
    },

    countySelectionLink (fid, query = {}) {
      return {
        name: 'movement',
        params: {
          fid
        },
        query
      }
    }
  }
}
